import { LegalDocView } from "@/components/marketing/LegalDocView";

export function TermsOfService() {
  return (
    <LegalDocView
      kind="terms_of_service"
      eyebrow="Terms"
      title="Plain-language terms of service."
    />
  );
}
